import { Component, Input } from '@angular/core';

export interface MenuChild {
  title: string;
  route: string;
}

@Component({
  selector: 'app-menu-section',
  templateUrl: './menu-section.component.html',
  styleUrls: ['./menu-section.component.scss']
})
export class MenuSectionComponent {
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() route: string = '';
  @Input() children: MenuChild[] = [];

  isOpen: boolean = false;

  toggle(event: Event): void {
    this.isOpen = !this.isOpen;
  }

}
